/**
 * Format a byte count into a human-readable file size string.
 */
export function formatFileSize(bytes: number): string {
  if (bytes === 0) {
    return '0 B';
  }
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${Math.round((bytes / Math.pow(k, i)) * 10) / 10} ${sizes[i]}`;
}

/**
 * Derive a file type key from extension and/or MIME type.
 * Returns a short token like 'pdf', 'doc', 'image', etc.
 */
export function getFileTypeKey(filename: string, mimeType?: string): string {
  const extension = filename.toLowerCase().split('.').pop() || '';

  if (extension === 'pdf' || mimeType === 'application/pdf') {
    return 'pdf';
  }
  if (
    ['doc', 'docx'].includes(extension) ||
    [
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    ].includes(mimeType || '')
  ) {
    return 'doc';
  }
  if (
    ['xls', 'xlsx'].includes(extension) ||
    [
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    ].includes(mimeType || '')
  ) {
    return 'xls';
  }
  if (extension === 'csv' || mimeType === 'text/csv') {
    return 'csv';
  }
  if (
    ['ppt', 'pptx'].includes(extension) ||
    [
      'application/vnd.ms-powerpoint',
      'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    ].includes(mimeType || '')
  ) {
    return 'ppt';
  }
  if (
    ['txt', 'md', 'rtf'].includes(extension) ||
    mimeType?.startsWith('text/')
  ) {
    return 'txt';
  }
  if (
    ['zip', 'tar', 'gz', '7z', 'rar'].includes(extension) ||
    [
      'application/zip',
      'application/x-tar',
      'application/gzip',
      'application/x-7z-compressed',
      'application/x-rar-compressed',
    ].includes(mimeType || '')
  ) {
    return 'zip';
  }
  if (
    ['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg', 'bmp', 'tiff', 'tif'].includes(
      extension
    ) ||
    mimeType?.startsWith('image/')
  ) {
    return 'image';
  }
  return 'default';
}
